import React, { Component } from "react";
import Swal from "sweetalert2";

import PerfectScrollbar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";

//Componentes auxiliares:
import CustomModal from "../../../tools/components/CustomModal";
import CustomCheckbox from "../../../tools/components/CustomCheckbox";

//Scripts auxiliares:
import {
  getSourceSubtitleText,
  getSourceTitleText,
} from "../../../views/common/downloadSourcesRenderingFunctions";
import RadioButton from "../../downloadSourcesConfiguration/components/RadioButton";

class ExecuteActionButton extends Component {
  constructor(props) {
    super();
    this.processSource = undefined; // props.downloadSource.source_process?.[0];
    let actionDetails = undefined; //[];
    // if (this.processSource?.process_detail?.interactive_data) {
    //   actionDetails = this.processSource?.process_detail?.interactive_data?.map(
    //     (d) => {
    //       d.download = d.download === "true";
    //       return d;
    //     }
    //   );
    // }
    this.state = {
      displayType: "checkbox",
      actionDetails,
      filesDetail: [],
      processDetail: [],
      isTheModalOpen: false,
      selectAll: true,
    };
  }

  checkIfButtonShouldBeVisible = () => {
    if (
      this.props.downloadSource.sources_process?.[0].process_detail
        ?.interactive_data
    ) {
      return true;
    }
    if (this.props.downloadSource.status === "WAITING_FOR_USER_ACTION") {
      return true;
    }
    return false;
  };

  getButtonTitle = () => {
    // if (this.props.downloadSource.status === "downloading")
    //   return "Descarga en proceso";

    // if (!this.props.activeUser.is_staff && !this.props.activeUser.is_admin)
    //   return "Permisos insuficientes";

    return "Guardar";
  };
  render() {
    return this.checkIfButtonShouldBeVisible() ? (
      <React.Fragment>
        <button
          className="btn btn-default"
          style={{
            padding: "8px 15px",
            backgroundColor: "transparent",
            color: "#65615c",
          }}
          onClick={this.modalToggle}
          title={this.getButtonTitle()}
        >
          <i className="fas fa-user-gear"></i>
          <b style={{ marginLeft: 5, ...this.props.textStyle }}>
            Accion Usuario
          </b>
        </button>
        {this.getUserActionModal()}
      </React.Fragment>
    ) : (
      <></>
    );
  }

  getModalTitleBasedOnStatus = () => {
    return (
      <p style={{ marginBottom: 5, textTransform: "capitalize" }}>
        <b>{getSourceTitleText(this.props.downloadSource.description)}</b>
        <span style={{ textTransform: "none" }}>
          {getSourceSubtitleText(this.props.downloadSource.description)}
        </span>
      </p>
    );
  };

  componentDidUpdate(prevProps, prevState) {
    // try {
    //   if (
    //     prevProps.downloadSource.modified !== this.props.downloadSource.modified
    //   ) {
    //     this.updateProcessInfo();
    //   }
    // } catch (error) {}
  }

  //Métodos operativos:
  modalToggle = () => {
    this.setState({ isTheModalOpen: !this.state.isTheModalOpen });
    if (!this.state.isTheModalOpen) {
      this.processSource = this.props.downloadSource.source_process?.[0];
      let actionDetails = [];
      if (this.processSource?.process_detail?.interactive_data) {
        actionDetails =
          this.processSource?.process_detail?.interactive_data?.map((d) => {
            d.download = d.download === "true";
            return d;
          });
      }

      this.setState({
        actionDetails: actionDetails,
        displayType:
          this.processSource?.process_detail?.process_pipe?.display_type,
      });
      console.log("actionDetails", actionDetails);
    }
  };

  // updateProcessInfo = () => {
  //   // console.log(`updateProcessInfo this.props.targetProcess  ${this.props.targetProcess}`);
  //   if (this.props.targetProcess !== undefined) {
  //     fetch(
  //       process.env.REACT_APP_API_URL +
  //         "/process/" +
  //         this.props.targetProcess.id +
  //         "/detail/",
  //       {
  //         method: "get",
  //         headers: {
  //           Authorization: "Token " + this.props.activeUser.authToken,
  //         },
  //       }
  //     )
  //       .then((serverResponse) => {
  //         serverResponse
  //           .json()
  //           .then((processDetail) => {
  //             if (
  //               JSON.stringify(this.state.processDetail) !==
  //               JSON.stringify(processDetail)
  //             ) {
  //               this.setState({ processDetail: processDetail });
  //             }
  //           })
  //           .catch((error) => console.log(error));
  //       })
  //       .catch((error) => console.log(error));

  //     if (
  //       this.props.targetProcess.status === "SUCCESS" ||
  //       this.props.targetProcess.status === "WARNING"
  //     ) {
  //       fetch(
  //         process.env.REACT_APP_API_URL +
  //           "/processes/" +
  //           this.props.targetProcess.id +
  //           "/get_file_info/",
  //         {
  //           method: "get",
  //           headers: {
  //             Authorization: "Token " + this.props.activeUser.authToken,
  //           },
  //         }
  //       )
  //         .then((serverResponse) => {
  //           if (serverResponse.status === 200) {
  //             serverResponse.json().then((filesDetail) => {
  //               if (
  //                 JSON.stringify(this.state.filesDetail) !==
  //                 JSON.stringify(filesDetail)
  //               ) {
  //                 this.setState({ filesDetail: filesDetail });
  //               }
  //             });
  //           }

  //           if (serverResponse.status === 400) {
  //             serverResponse.json().then((fetchErrorDetail) => {
  //               console.log(fetchErrorDetail);
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     }
  //   }
  // };

  getFooterButtonsBasedOnStatus = () => {
    let userCanClickTheButton =
      false || this.props.activeUser.is_admin || this.props.activeUser.is_staff;
    let buttonsList = [];

    let getSaveButton = () => {
      return (
        <Button
          color="danger"
          key={"botonParaFooter.saveButton"}
          disabled={!userCanClickTheButton}
          onClick={(e) => {
            console.log(
              "this.props.downloadSource  this.state.actionDetails",
              this.props.targetProcess,
              this.state.actionDetails
            );
            const list = this.state.actionDetails.filter((a) => a.download);
            if (list.length === 0) {
              Swal.fire(
                "",
                "Debe seleccionar al menos un archivo para descargar",
                "warning"
              );
            } else {
              this.props.onClick(
                e,
                this.props.downloadSource,
                this.state.actionDetails
              );
              this.modalToggle();
            }
          }}
        >
          Guardar
        </Button>
      );
    };

    buttonsList.push(getSaveButton());
    return buttonsList;
  };

  getItems = () => {
    let items = [];
    console.log(
      "this.state.actionDetails --------------------",
      this.state.actionDetails?.length
    );

    // }
    if (this.state.actionDetails) {
      for (let i = 0; i < this.state.actionDetails.length; i++) {
        try {
          let item = this.state.actionDetails[i];
          console.log(
            "🚀 ~ file: ExecuteActionButton.jsx:253 ~ ExecuteActionButton ~ item:",
            i,
            this.state.actionDetails[i]
          );

          items.push(
            <li className="timeline-inverted" key={"itemDeProceso." + "." + i}>
              {this.state.displayType === "checkbox" ? (
                <CustomCheckbox
                  checked={this.state.actionDetails[i].download}
                  id={i}
                  key={i}
                  itemRendering={
                    item[
                      this.processSource.process_detail?.process_pipe
                        ?.label_html
                    ]
                  }
                  onChange={(newValue, event) => {
                    console.log(
                      "🚀 ~ file: ExecuteActionButton.jsx:285 ~ ExecuteActionButton ~ newValue:",
                      newValue
                    );
                    let actionDetails = this.state.actionDetails;
                    actionDetails[
                      event.target.getAttribute("data-id")
                    ].download = newValue;
                    this.setState({ actionDetails: actionDetails });
                  }}
                />
              ) : (
                <RadioButton
                  downloadSource={i}
                  label={item[
                    this.processSource.process_detail?.process_pipe
                      ?.label_html
                  ]}
                  key={i}
                  checked={this.state.actionDetails[i].download}
                  onClick={(newDownloadSource, event) => {
                    console.log(
                      "🚀 ~ file: ExecuteActionButton.jsx:285 ~ ExecuteActionButton ~ newDownloadSource:",
                      newDownloadSource
                    );
                    let actionDetails = this.state.actionDetails;
                    for(let ad of actionDetails){
                      ad.download = false;
                    }
                    actionDetails[
                      newDownloadSource
                    ].download = true;
                    this.setState({ actionDetails: actionDetails });
                  }}
                />
              )}
            </li>
          );
        } catch (error) {
          console.log(
            "🚀 ~ file: ExecuteActionButton.jsx:281 ~ ExecuteActionButton ~ error:",
            error
          );
          console.error(error);
        }
      }
    }
    console.log("items", items.length);
    return items;
  };
  getUserActionModal = () => {
    console.log(`getUserActionModal`, this.props.downloadSource);
    if (this.props.downloadSource !== undefined) {
      return (
        <CustomModal
          isTheModalOpen={this.state.isTheModalOpen}
          modalToggle={this.modalToggle}
          title={this.getModalTitleBasedOnStatus()}
          footerButtons={this.getFooterButtonsBasedOnStatus()}
        >
          {/* <CustomCheckbox
            checked={true}
            id={"all"}
            key={"all"}
            itemRendering={"Seleccionar todos"}
            onChange={(newValue, event) => {
              let actionDetails = this.state.actionDetails;
              console.log(
                "🚀 ~ file: ExecuteActionButton.jsx:311 ~ actionDetails:",
                actionDetails
              );
              console.log(
                "🚀 ~ file: ExecuteActionButton.jsx:307 ~ newValue:",
                newValue
              );
              actionDetails = actionDetails.map((a) => (a.download = newValue));

              this.setState({
                actionDetails: actionDetails,
                selectAll: newValue,
              });
            }}
          /> */}
          <Row>
            <Col
              xs="12"
              md="12"
              lg="12"
              xl="12"
              style={{ marginTop: 10, paddingLeft: 10, paddingRight: 10 }}
            >
              <PerfectScrollbar style={{ paddingTop: 15, maxHeight: 260 }}>
                <ul
                  className="timeline"
                  style={{ paddingBottom: 0, marginBottom: 0 }}
                >
                  {this.getItems()}
                </ul>
              </PerfectScrollbar>
            </Col>
          </Row>
        </CustomModal>
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    activeUser: state.mainReducer.activeUser,
  };
};

export default connect(mapStateToProps)(ExecuteActionButton);
